import { css } from '@emotion/css';
import { appColors, breakpoints, fontWeight } from '../styles/variables.style';
import check from '../assets/images/check.png';

export const multiChoice = css`
  @media (min-width: ${breakpoints.lg.up}) {
    display: flex;
  }

  .leftpanel {
    flex: 0 0 60%;
    padding: 10px;
    text-align: center;

    @media (min-width: ${breakpoints.lg.up}) {
      padding: 20px;
    }

    .quiz-img {
      max-width: 320px;
      display: block;
      width: 180px;
      height: 180px;
      object-fit: contain;
      margin: 0 auto 30px;
    }

    .s-title {
      font-size: 20px;
      color: ${appColors.gray800};
      margin: 0 0 30px;

      @media (min-width: ${breakpoints.lg.up}) {
        font-size: 28px;
      }
    }
  }

  .rightpanel {
    background: ${appColors.orange};
    padding: 20px 15px;
    border-radius: 0 10px 10px 0;
    display: flex;
    flex-direction: column;
    flex: 0 0 40%;

    @media (min-width: ${breakpoints.lg.up}) {
      padding: 30px 45px;
    }

    .s-title {
      font-size: 24px;
      text-align: center;
      color: ${appColors.white};
      margin: 0 0 30px;
      position: relative;

      @media (min-width: ${breakpoints.lg.up}) {
        font-size: 28px;
        margin: 0 0 40px;
      }

      &::before {
        content: '';
        position: absolute;
        top: 7px;
        left: -23px;
        width: 15px;
        height: 15px;
        background: ${appColors.white};
        transform: rotate(45deg);

        @media (min-width: ${breakpoints.lg.up}) {
          width: 30px;
          height: 30px;
          left: -60px;
          top: 0;
        }
      }
    }

    .btn-group {
      margin-top: auto;
      text-align: right;

      button {
        background: none;
        color: ${appColors.white};
        text-transform: uppercase;
        font-size: 18px;
        font-weight: ${fontWeight.bold};
        padding: 0 10px;

        &:hover {
          background: none;
          color: ${appColors.gray200};
        }
      }
    }
  }
`;

export const input = css`
  display: flex;
  align-items: start;
  padding: 18px 20px;
  width: 100%;
  height: auto;
  background: ${appColors.white};
  border-radius: 8px;
  margin-bottom: 20px;

  @media (min-width: ${breakpoints.lg.up}) {
    max-width: 420px;
  }

  & > div {
    display: flex;
    color: ${appColors.gray800};
    font-size: 16px;

    @media (min-width: ${breakpoints.lg.up}) {
      font-size: 18px;
    }
  }

  &:hover {
    cursor: pointer;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  }

  .radiobutton {
    margin-right: 15px;

    &::before {
      width: 26px;
      height: 26px;
      border-color: ${appColors.gray800};
      border-width: 1px;
    }

    &:checked::before {
      background: ${appColors.orange} url(${check}) no-repeat center/20px;
      border-color: ${appColors.orange};
    }
  }
`;

export const imgPoster = css`
  display: block;
  margin: 0 auto 20px;
  width: auto;
  max-width: 100%;
  height: 300px;
  object-fit: contain;
`;
